export const LSD_STATUS = {
  WAITING_FOR_ETH: 'WAITING_FOR_ETH',
  READY_TO_STAKE: 'READY_TO_STAKE',
  STAKED: 'STAKED',
  BANNED: 'BANNED',
  DERIVATIVES_MINTED: 'MINTED_DERIVATIVES'
}
